import Observer from './vendor/observer.min';
import { formsPackage, calendarInput, calendarRangeInput } from './functions/form';
import masksPackage from './functions/masks';
import setConditions from './functions/conditions';
import limitedCheckboxLists from './functions/limitedCheckboxLists';
import repeaterButtons from './functions/repeaters';

export const OBSERVER = Observer.getInstance();

addEventListener('DOMContentLoaded', () => {
  initFormBuilder();
})

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const initFormBuilder = (classeContainerFormBuilder = '.dynamicForm') => {
  formsPackage(classeContainerFormBuilder);
  masksPackage();
  initFileUpload(classeContainerFormBuilder);
  setConditions();
  limitedCheckboxLists();
  repeaterButtons();
  calendarInput(classeContainerFormBuilder);
  calendarRangeInput(classeContainerFormBuilder);
};

window.initFormBuilder = initFormBuilder;
